<template>
  <div class="brand-wall-container">
    <div class="brand-header">
      <div class="header-content">
        <div class="header-title">品牌精选</div>
        <div class="header-subtitle"></div>
      </div>
      <!-- <div class="header-more">全部品牌</div> -->
    </div>
    
    <div class="brand-grid">
      <div 
        v-for="(brand, index) in brandList" 
        :key="index" 
        class="brand-item"
        @click="handleBrandClick(brand)"
      >
        <div class="brand-image-wrapper">
          <img 
            v-lazy="brand.bg || brand.image" 
            :alt="brand.name" 
            class="brand-image"
          />
          <div class="brand-name">{{ brand.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandWall',
  data() {
    return {
      brandList: [
        // { name: '海尔', color: '#1890ff', image: 'https://via.placeholder.com/120x80/40a9ff/ffffff?text=海尔' },
        // { name: '美的', color: '#ff4d4f', image: 'https://via.placeholder.com/120x80/ff4d4f/ffffff?text=美的' },
        { name: '罗莱健康', color: '#722ed1', image: 'https://bank.giftoceanmall.com/c474c202605281359114682.jpg',path:'/search?keyword=罗莱健康' },
        { name: '名创优品', color: '#faad14', image: 'https://bank.giftoceanmall.com/95f05202605281359302622.jpg',path:'/search?keyword=名创优品' },
        { name: '飞利浦', color: '#08979c', image: 'https://bank.giftoceanmall.com/20ac5202605281358051152.jpg',path:'/search?keyword=飞利浦' },     
        { name: '完美日记', color: '#eb2f96', image: 'https://bank.giftoceanmall.com/b2561202605281401056772.jpg',path:'/search?keyword=完美日记' },
        { name: '蔬果园', color: '#52c41a', image: 'https://bank.giftoceanmall.com/b80cf202605281400339589.jpg',path:'/search?keyword=蔬果园' },
        { name: '公牛', color: '#ff6b6b', image: 'https://bank.giftoceanmall.com/2e59d20260528135819460.jpg',path:'/search?keyword=公牛' },
        { name: '韶音', color: '#722ed1', image: 'https://bank.giftoceanmall.com/56deb202605281359456662.jpg',path:'/search?keyword=韶音' },
        { name: '滋源', color: '#009688', image: 'https://bank.giftoceanmall.com/d4e2e202605281401349237.jpg',path:'/search?keyword=滋源' },
        { name: '周大生', color: '#faad14', image: 'https://bank.giftoceanmall.com/8c012202605281401214347.jpg',path:'/search?keyword=周大生' },
        { name: '创维', color: '#096dd9', image: 'https://bank.giftoceanmall.com/451fd202605281357316892.jpg',path:'/search?keyword=创维' },
        { name: '康佳', color: '#722ed1', image: 'https://bank.giftoceanmall.com/e18de20260528135842113.jpg',path:'/search?keyword=康佳' },
        { name: '卡萨帝', color: '#006d75', image: 'https://bank.giftoceanmall.com/cc4a6202605281358298352.jpg',path:'/search?keyword=卡萨帝' },
        { name: '奥克斯', color: '#52c41a', image: 'https://bank.giftoceanmall.com/e8f0e202605281357067546.jpg',path:'/search?keyword=奥克斯' }
      ]
    }
  },
  methods: {
    handleBrandClick(brand) {
      if (brand.path) {
        this.$router.push(brand.path)
      }
      // 触发品牌点击事件
      this.$emit('brandClick', brand)
    }
  }
}
</script>

<style lang="scss" scoped>
.brand-wall-container {
  background: #fff;
  padding: 0.3rem;
  margin-top: 0.2rem;
}

.brand-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.2rem;
  
  .header-content {
    display: flex;
    flex-direction: column;
  }
  
  .header-title {
    font-size: 0.32rem;
    font-weight: bold;
    color: #333;
  }
  
  .header-subtitle {
    font-size: 0.22rem;
    color: #999;
    margin-top: 0.08rem;
  }
  
  .header-more {
    font-size: 0.24rem;
    color: #ff4d4f;
  }
}

.brand-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.15rem;
}

.brand-item {
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:active {
    opacity: 0.7;
    transform: scale(0.95);
  }
}

.brand-image-wrapper {
  position: relative;
  width: 100%;
  padding-top: 66.67%;
  border-radius: 0.1rem;
  overflow: hidden;
  background: #f5f5f5;
}

.brand-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.brand-name {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.1rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
  color: #fff;
  font-size: 0.2rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 移动端适配 */
@media screen and (max-width: 480px) {
  .brand-wall-container {
    padding: 0.25rem;
  }
  
  .brand-grid {
    grid-template-columns: repeat(5, 1fr);
    gap: 0.12rem;
  }
  
  .brand-name {
    font-size: 0.18rem;
    padding: 0.08rem;
  }
}
</style>